$(document).ready(function () {
  var contactpage = (function () {
    var $formSelector;
    var $forms;

    var init = function ($selector, $formsContainer) {
      $formSelector = $selector;
      $forms = $formsContainer.find('form');

      $formSelector.on('change', function (event) {
        activateForm($(event.target).val())
      });

      // Show the first form by default
      activateForm(0);
    };


    var activateForm = function (indexShow) {
      $forms.each(function (index) {
        if (index.toString() === indexShow.toString()) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    };

    return {
      init: init
    };
  })();

  contactpage.init(
    $('#form-selector'),
    $('.js-contact-form-switcher')
  );
});
